.autoCompleteRoot {
  position: relative;
  width: 100%;
  display: flex;
}

.autoCompleteDropdownContainer {
  position: absolute;
  top: calc(80px);
  z-index: 10;
  border: 1px solid var(--color-border-separator);
  border-top: 0;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  background-color: var(--color-background-primary);
  padding: var(--size-spacing-md) 0;
  width: 100%;
}

.autoCompleteSuggestion {
  cursor: pointer;
  padding: 10px 15px;
  color: var(--color-text-body-primary);
}

.autoCompleteSuggestionActive {
  background-color: var(--color-background-tertiary);
  cursor: pointer;
  padding: 10px 15px;
  color: var(--color-text-body-primary);
}

.autoCompleteSpinnerContainer {
  display: flex;
  justify-content: center;
  border: 0;
  box-shadow: none;
  color: var(--color-text-body-primary);
}
